<template>
  <div id="ticket-editor-modal">
    
    <memlist-modal ref="edit-ticket" :title="local_item.name" size="xl" hide-footer>
      

      <m-row>
        <m-col lg="6">
          <memlist-text-input
            id="name"
            name="name"
            layout="vertical"
            :title="$t('EVENT.TICKET.NAME')"
            validation_type="TEXT"
            v-model="local_item.name"
            @change="$emit('change', local_item)"
          />
        </m-col>
      </m-row>
      <m-row>
        <m-col lg="6">
          
          <memlist-text-input
            id="description"
            name="description"
            layout="vertical"
            :title="$t('EVENT.TICKET.DESCRIPTION')"
            validation_type="TEXT"
            v-model="local_item.description"
            @change="$emit('change', local_item)"
          />

        </m-col>
      </m-row>
      <m-row>
        <m-col lg="4">
          
          <memlist-text-input
            id="amount"
            name="amount"
            layout="vertical"
            :title="$t('EVENT.TICKET.AMOUNT')"
            validation_type="TEXT"
            v-model="local_item.amount"
            @change="$emit('change', local_item)"
          />
        </m-col>
        <m-col lg="4">
          <memlist-text-input
            id="amount_vat"
            name="amount_vat"
            layout="vertical"
            :title="$t('EVENT.TICKET.AMOUNT_VAT')"
            validation_type="TEXT"
            v-model="local_item.amount_vat"
            @change="$emit('change', local_item)"
          />
        </m-col>
        <m-col lg="4">
          <memlist-select-input2
            id="currency"
            name="currency"
            :title="$t('PAGES.SHOPITEM.CURRENCY')"
            layout="vertical"
            validation_type="TEXT"
            v-model="local_item.currency"
            :items="currency_options"
            :invalid_text="''"
            :info_text="''"
          />
        </m-col>
      </m-row>
      <m-row v-if="local_item.age_options">
        <m-col lg="6">
           
          <memlist-checkbox 
            :text="$t('EVENT.TICKET.ENABLED')"
            style="margin-top: 20px;"
            v-model="local_item.age_options.enabled"
          />
        </m-col>
      </m-row>

      <m-row v-if="local_item.age_options && local_item.age_options.enabled">
        <m-col lg="6">

          <memlist-text-input
            id="age_from"
            name="age_from"
            layout="vertical"
            :title="$t('EVENT.TICKET.AGE_FROM')"
            validation_type="TEXT"
            v-model="local_item.age_options.age_from"
            @change="$emit('change', local_item)"
          />
        </m-col>
        <m-col lg="6">

          <memlist-text-input
            id="age_to"
            name="age_to"
            layout="vertical"
            :title="$t('EVENT.TICKET.AGE_TO')"
            validation_type="TEXT"
            v-model="local_item.age_options.age_to"
            @change="$emit('change', local_item)"
          />
        </m-col>

      </m-row>
        
      <m-row>
        <m-col lg="6">
          
          <memlist-text-input
            id="max_quantity"
            name="max_quantity"
            layout="vertical"
            :title="$t('EVENT.TICKET.MAX_QUANTITY')"
            validation_type="TEXT"
            v-model="local_item.max_quantity"
            @change="$emit('change', local_item)"
          />
        </m-col>
        <m-col lg="6">
          <memlist-text-input
            id="used_quantity"
            name="used_quantity"
            layout="vertical"
            :title="$t('EVENT.TICKET.USED_QUANTITY')"
            validation_type="TEXT"
            v-model="local_item.used_quantity"
            @change="$emit('change', local_item)"
            disabled
          />
        </m-col>
      </m-row>

      <m-row>
        <m-col lg="6">
          <memlist-select-input2
            id="shop_item_id"
            name="shop_item_id"
            :title="$t('EVENT.TICKET.CONNECTED_SHOP_ITEM')"
            layout="vertical"
            validation_type="TEXT"
            v-model="local_item.shop_item_id"
            :items="shop_item_options"
            :invalid_text="''"
            :info_text="''"
          />
          <p class="mt-2" style="font-style: italic; color: #888888;">Kopplad butiksartikel används för bokföring. Gå till "Butik/Medlemskap" för att redigera.</p>
        </m-col>
      </m-row>
      <m-row>
        <m-col lg="6">
              
          <p class="mt-4" style="font-weight: bold; margin-bottom: 4px !important;">{{ $t('EVENT.TICKET.COMPANIES') }}</p>
          <Multiselect
            class="multiselect-blue"
            v-model="local_item.company_ids"
            ref="companies_multiselect"
            mode="tags"
            :placeholder="$t('EVENT.TICKET.COMPANIES')"
            :close-on-select="false"
            :filter-results="false"
            :min-chars="0"
            :resolve-on-load="true"
            :delay="0"
            :searchable="true"
            :options="async function(query) {
              return await fetch_company_options(query);
            }"
          />
          <p class="mt-2" style="font-style: italic; color: #888888;">Lägg till vilka föreningar som medlemskap krävs för att kunna köpa biljett. Om inga föreningar är valda antas att inget medlemskap i förening krävs.</p>

        </m-col>
      </m-row>
      <m-row>
        <m-col lg="6">
              
          <memlist-checkbox 
            :text="$t('EVENT.TICKET.IS_ACTIVE')"
            style="margin-top: 20px;"
            v-model="local_item.is_active"
          />

        </m-col>
      </m-row>
      
      <m-row>
        <m-col lg="12">
          <RightModalSaveAndCloseButtons
            class="mt-4"
            :text="$t('COMMON.SAVE')"
            :spin="true"
            @clicked="save_ticket_clicked"
            @close="$refs['edit-ticket'].hide()"
            ref="saveButton"
          />
        </m-col>
      </m-row>
      
    </memlist-modal>

  </div>
</template>

<script>

import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import Multiselect from '@vueform/multiselect/dist/multiselect.vue2.js'

export default {
  name: 'EventTypeEditorModal',
  components: {
    Multiselect
  },
  mixins: [ toasts ],
  computed: {

    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'pages', 'companies']),
    currency_options() {
      return [
        { text: 'SEK', value: 'SEK' },
        { text: 'EUR', value: 'EUR' },
      ]
    },
    company_options() {
      if (!this.companies) {
        return [];
      }

      let comps = this.companies.map((item) => ({ text: item.shortname && item.shortname.length > 0 ? item.shortname : item.name, value: item.id }));

      comps.sort((a, b) => {
        if (a < b) {
          return -1;
        }

        return 1;
      });

      return comps;
    },
  },
  props: ['id','event'],
  watch: {
    currentCompanyId() {
      this.fetch_shop_items();
    },
    async id() {
      if (!this.id) {
        this.local_item = {
          age_options: {
            enabled: false,
            age_from: null,
            age_to: null
          }
        };
      }
      else {
        await this.fetch_ticket(this.id);
      }

      await this.fetch_shop_items();
    }
  },
  emits: ['created', 'updated', 'deleted'],
  async mounted() {
    

    setTimeout(() => {
      if (this.$refs.companies_multiselect) {
        this.$refs.companies_multiselect.refreshOptions()
      }
    }, 500);
  },
  methods: {

    async fetch_company_options(query) {
      if (!this.companies?.length) {
        return []
      }

      let res_companies = [...this.companies];

      if (query?.length) {
        res_companies = this.companies.filter(item => item.name.toLowerCase().includes(query?.toLowerCase()));
      }

      return res_companies.map(item => ({ label: item.name, value: item.company_id }));
    },

    async fetch_ticket(id) {
      const res = await axios.get(`/events/tickets/${id}`);
      
      if (res.status !== 200) {
        this.local_item = {
          currency: 'SEK',
          age_options: {
            enabled: false,
            age_from: null,
            age_to: null
          }
        };

        return false;
      }

      this.local_item = res.data;

      if (!this.local_item.age_options) {
        this.local_item.age_options = {
          enabled: false,
          age_from: null,
          age_to: null
        }
      }
    },

    async fetch_shop_items() {
      const res = await axios.post(`/shop_item/pagination`, { options: { company_ids: [this.currentCompanyId], is_ticket: true } } );
      
      if (res.status !== 200) {
        return false;
      }

      this.shop_item_options = res.data.map(i => ({ text: i.name, value: i.shop_item_id }));

      if (this.local_item && !this.local_item.shop_item_id) {
        this.local_item.shop_item_id = res.data.find(item => item.is_ticket && item.is_default).shop_item_id;
      }

    },

    show() {
      this.$refs['edit-ticket'].show();
    },

    async save_ticket_clicked() {
      if (this.local_item.id) {
        await this.put_ticket(this.local_item);
      }
      else {
        await this.post_ticket(this.local_item);
      }

      this.$refs['saveButton'].stop();
    },


    async delete_ticket(id) {
      try {
        const res = await axios.delete(`/events/tickets/${id}`);

        if (res.status === 204) {
          this.toastr('success', this.$t('COMMON.SUCCESS'), this.$t('EVENT.TYPES.DELETED'));
          this.$emit('deleted', id);

          return;
        }

        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.TYPES.UNABLE_DELETE'));
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.TYPES.UNABLE_DELETE'));
      }
    },

    async put_ticket(item) {
      try {
        const res = await axios.put(`/events/tickets/${item.id}`, item);

        if (res.status === 204) {
          this.toastr('success', this.$t('COMMON.SUCCESS'), this.$t('EVENT.TICKET.UPDATED'));

          this.$emit('updated', item);

          return;
        }

        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.TICKET.UNABLE_UPDATE'));
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.TICKET.UNABLE_UPDATE'));
      }
    },

    async post_ticket(item) {
      try {
        const res = await axios.post(`/events/${this.event.event_id}/tickets`, item);

        if (res.status === 201) {
          this.toastr('success', this.$t('COMMON.SUCCESS'), this.$t('EVENT.TICKET.CREATED'));

          this.local_item = res.data;
          this.$emit('created', res.data);

          return res.data;
        }

        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.TICKET.UNABLE_CREATE'));
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.TICKET.UNABLE_CREATE'));
      }
    },

    reset() {
      this.local_item = {
        currency: 'SEK',
        age_options: {
          enabled: false,
          age_from: null,
          age_to: null
        }
      };

      this.fetch_shop_items();
    }
  },
  data() {
    return {
      shop_item_options: [],
      active_tab: 0,
      local_item: {
        currency: 'SEK'
      }
    };
  },
  
};
</script>
<style lang="scss" scoped>

@import "@/assets/sass/components/forms/_memlist_tabs2.scss";

.m-row { margin-top: 16px; }

</style>